var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.currentComponent,{ref:"mainProPage",tag:"component",attrs:{"productId":_vm.id},on:{"getBack":_vm.showDetailPage1}})
}
var staticRenderFns = []

export { render, staticRenderFns }